import { apiSlice } from './apiSlice';

export const checkoutApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    priceCheckout: builder.mutation({
      query: (body) => ({
        url: '/api/checkout/price',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { usePriceCheckoutMutation } = checkoutApiSlice;
